import React from 'react';
import { motion } from 'framer-motion';
import { Coffee, Leaf, Moon, Pill } from 'lucide-react';
const failures = [{
  icon: Coffee,
  title: 'Coffee',
  description: 'Coffee only blocks the tiredness signal, but it doesn\'t recharge your cellular "battery"; in fact, it speeds up the loss of essential minerals through urine.'
}, {
  icon: Leaf,
  title: '"Clean" Diets',
  description: '"Clean" diets are a great step, but because modern agricultural soils are depleted, it\'s nearly impossible to get optimal levels of certain minerals from food alone.'
}, {
  icon: Moon,
  title: 'Sleeping More',
  description: 'Sleeping more does not repair biochemical damage if your mitochondria are missing the co-factors needed to produce real energy (ATP).'
}, {
  icon: Pill,
  title: 'Generic Multivitamins',
  description: 'Generic drugstore multivitamins have low bioavailability; your body eliminates 90% before they ever reach your bloodstream.'
}];
export function WhyItFailed() {
  return <section className="py-24 px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-201">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-16" data-id="element-202">
        <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-203">
          Why What You Tried Didn't Work
        </h2>
        <p className="text-xl text-charcoal/70 max-w-2xl mx-auto" data-id="element-204">
          You aren't failing because of a lack of effort. You're failing because
          you've been using the wrong tools.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-205">
        {failures.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white p-8 rounded-2xl border border-forest/10 shadow-sm flex flex-col md:flex-row gap-6 items-start" data-id="element-206">
            <div className="w-14 h-14 shrink-0 bg-forest/5 text-forest rounded-xl flex items-center justify-center" data-id="element-207">
              <item.icon size={28} data-id="element-208" />
            </div>
            <div data-id="element-209">
              <h3 className="text-2xl font-serif font-bold mb-3" data-id="element-210">
                {item.title}
              </h3>
              <p className="text-charcoal/80 leading-relaxed" data-id="element-211">
                {item.description}
              </p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}